<template>
  <div class="page">
    <!-- 顶部渐变条 -->
    <div class="top-bar"></div>

    <!-- 背景装饰圆 -->
    <div class="bg-decoration bg-decoration-1"></div>
    <div class="bg-decoration bg-decoration-2"></div>
    <div class="bg-decoration bg-decoration-3"></div>

    <div class="container">
      <!-- 头部 -->
      <div class="header">
        <div class="header-left">
          <!-- <div class="logo-icon">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/>
            </svg>
          </div> -->
          <div>
            <h1>学院端</h1>
            <p class="subtitle">题库选择 · 视频考试</p>
          </div>
        </div>
        <div class="header-right">
          <div class="user-info">
            <!-- <div class="user-avatar">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
            </div> -->
            <span class="user-name">{{ currentUser.realName || '学院端用户' }}</span>
          </div>
          <button class="logout-btn" @click="logout">
            <!-- <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg> -->
            退出登录
          </button>
        </div>
      </div>

      <!-- 可考试案例列表 -->
      <div class="section">
        <div class="section-header">
          <h2>
            <!-- <svg class="section-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
            </svg> -->
            可考试题库
          </h2>
          <button class="refresh-btn" @click="loadCases" :disabled="loading">
            <!-- <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" :class="{ spinning: loading }">
              <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
            </svg> -->
            刷新案例
          </button>
        </div>

        <div v-if="loading" class="loading">
          <div class="spinner"></div>
          <p>加载中...</p>
        </div>
        <div v-else-if="cases.length === 0" class="empty-state">
          <!-- <svg class="empty-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"/>
          </svg> -->
          <p>暂无可用案例</p>
        </div>
        <div v-else class="case-list">
          <div v-for="item in cases" :key="item.id" class="case-card">
            <div class="case-content">
              <h3 class="case-title">{{ item.title }}</h3>
              <p class="case-desc">{{ item.description }}</p>
            </div>
            <div class="case-actions">
              <button class="start-btn" @click="startExam(item)">
                <!-- <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5v14l11-7z"/>
                </svg> -->
                开始考试
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 历史考试记录 -->
      <div class="section">
        <div class="section-header">
          <h2>
            <!-- <svg class="section-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
            </svg> -->
            考试记录
          </h2>
        </div>

        <div v-if="examLoading" class="loading">
          <div class="spinner"></div>
          <p>加载中...</p>
        </div>
        <div v-else-if="examRecords.length === 0" class="empty-state">
          <!-- <svg class="empty-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
          </svg> -->
          <p>暂无考试记录</p>
        </div>
        <div v-else class="exam-table-wrapper">
          <table class="exam-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>案例</th>
                <th>分数</th>
                <th>提交时间</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(exam, index) in examRecords" :key="exam.id">
                <td>{{ index + 1 }}</td>
                <td class="case-title-cell">{{ exam.caseTitle || '未知案例' }}</td>
                <td>
                  <span class="score-badge" :class="getScoreClass(exam.score)">
                    {{ exam.score !== null ? exam.score : '未评分' }}
                  </span>
                </td>
                <td class="time-cell">{{ formatTime(exam.endTime) }}</td>
                <td>
                  <span :class="exam.status === 1 ? 'status-completed' : 'status-pending'">
                    <span class="status-dot"></span>
                    {{ exam.status === 1 ? '已完成' : '待评分' }}
                  </span>
                </td>
                <td>
                  <button class="view-btn" @click="viewExam(exam)">
                    <!-- <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                    </svg> -->
                    查看详情
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StudentHome',
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      cases: [],
      examRecords: [],
      loading: false,
      examLoading: false
    }
  },
  mounted() {
    this.loadCases()
    this.loadExamRecords()
  },
  methods: {
    async loadCases() {
      this.loading = true
      try {
        const response = await axios.get('/api/cases')
        if (Array.isArray(response.data)) {
          this.cases = response.data
        } else if (response.data && response.data.code === 200) {
          this.cases = response.data.data || []
        }
      } catch (error) {
        console.error('加载案例失败:', error)
        alert('加载失败：' + (error.response?.data?.message || error.message))
      } finally {
        this.loading = false
      }
    },
    async loadExamRecords() {
      this.examLoading = true
      try {
        const response = await axios.get(`/api/exams/user/${this.currentUser.id}`)
        if (Array.isArray(response.data)) {
          this.examRecords = response.data
        } else if (response.data && response.data.code === 200) {
          this.examRecords = response.data.data || []
        }
      } catch (error) {
        console.error('加载考试记录失败:', error)
      } finally {
        this.examLoading = false
      }
    },
    async startExam(caseItem) {
      try {
        const response = await axios.post('/api/exams', {
          userId: this.currentUser.id,
          caseId: caseItem.id,
          status: 0
        })
        
        if (response.data && response.data.code === 200) {
          const examId = response.data.data.id
          const studentId = this.currentUser.id || ''
          const query = `examId=${examId}&caseId=${caseItem.id}${studentId ? `&studentId=${studentId}` : ''}`
          const examPage = '/h5-exam.html'
          window.open(`${examPage}?${query}`, '_blank')
        } else {
          alert('创建考试失败')
        }
      } catch (error) {
        console.error('开始考试失败:', error)
        alert('开始考试失败:' + (error.response?.data?.message || error.message))
      }
    },
    viewExam(exam) {
      this.$router.push(`/exam-result?examId=${exam.id}`)
    },
    logout() {
      localStorage.removeItem('userInfo')
      this.$router.push('/login')
    },
    formatTime(time) {
      if (!time) return '未知时间'
      return new Date(time).toLocaleString()
    },
    getScoreClass(score) {
      if (score === null || score === undefined) return 'score-none'
      if (score >= 90) return 'score-excellent'
      if (score >= 80) return 'score-good'
      if (score >= 60) return 'score-pass'
      return 'score-fail'
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  background: #f0f4f8;
  min-height: 100vh;
  width: 100vw;
  padding: 20px;
  position: relative;
  overflow-x: hidden;
}

/* 顶部渐变条 */
.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #3B82F6, #06B6D4, #10B981);
  z-index: 100;
}

/* 背景装饰圆 */
.bg-decoration {
  position: fixed;
  border-radius: 50%;
  opacity: 0.06;
  pointer-events: none;
}

.bg-decoration-1 {
  width: 400px;
  height: 400px;
  background: #3B82F6;
  top: -100px;
  right: -100px;
}

.bg-decoration-2 {
  width: 300px;
  height: 300px;
  background: #06B6D4;
  bottom: -80px;
  left: -80px;
}

.bg-decoration-3 {
  width: 200px;
  height: 200px;
  background: #10B981;
  top: 50%;
  left: 10%;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* 头部 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  margin-bottom: 24px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(59, 130, 246, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
  animation: slideUp 0.6s ease-out;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.logo-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-icon svg {
  width: 28px;
  height: 28px;
  fill: #ffffff;
}

.header h1 {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.subtitle {
  font-size: 13px;
  color: #64748b;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-avatar svg {
  width: 20px;
  height: 20px;
  fill: #ffffff;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: #f8fafc;
  color: #64748b;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.25s ease;
}

.logout-btn svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
}

.logout-btn:hover {
  background: #ef4444;
  color: #ffffff;
  border-color: #ef4444;
}

/* 区块 */
.section {
  margin-bottom: 24px;
  padding: 28px 32px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(59, 130, 246, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
  animation: slideUp 0.6s ease-out;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f5f9;
}

.section-header h2 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.section-icon {
  width: 24px;
  height: 24px;
  fill: #3B82F6;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.refresh-btn svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
}

.refresh-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

.refresh-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.spinning {
  animation: spin 0.8s linear infinite;
}

/* 案例列表 */
.case-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.case-card {
  padding: 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.case-card:hover {
  border-color: #3B82F6;
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.12);
  transform: translateY(-4px);
}

.case-content {
  flex: 1;
  margin-bottom: 16px;
}

.case-title {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 10px;
  line-height: 1.4;
}

.case-desc {
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
}

.case-actions {
  display: flex;
  gap: 10px;
}

.start-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 24px;
  background: linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.start-btn svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}

.start-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

/* 考试表格 */
.exam-table-wrapper {
  overflow-x: auto;
}

.exam-table {
  width: 100%;
  border-collapse: collapse;
}

.exam-table th,
.exam-table td {
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
  font-size: 14px;
}

.exam-table th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.exam-table tbody tr {
  transition: background 0.2s;
}

.exam-table tbody tr:hover {
  background: #f8fafc;
}

.case-title-cell {
  font-weight: 600;
  color: #1e293b;
}

.time-cell {
  color: #64748b;
  font-size: 13px;
}

.score-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
}

.score-excellent {
  background: rgba(16, 185, 129, 0.1);
  color: #10B981;
}

.score-good {
  background: rgba(59, 130, 246, 0.1);
  color: #3B82F6;
}

.score-pass {
  background: rgba(245, 158, 11, 0.1);
  color: #F59E0B;
}

.score-fail {
  background: rgba(239, 68, 68, 0.1);
  color: #EF4444;
}

.score-none {
  background: rgba(148, 163, 184, 0.1);
  color: #94A3B8;
}

.status-completed,
.status-pending {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-completed {
  color: #10B981;
}

.status-completed .status-dot {
  background: #10B981;
}

.status-pending {
  color: #F59E0B;
}

.status-pending .status-dot {
  background: #F59E0B;
}

.view-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #f8fafc;
  color: #3B82F6;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.view-btn svg {
  width: 14px;
  height: 14px;
  fill: currentColor;
}

.view-btn:hover {
  background: #3B82F6;
  color: #ffffff;
  border-color: #3B82F6;
}

/* 加载和空状态 */
.loading, .empty-state {
  text-align: center;
  padding: 60px 20px;
}

.spinner {
  display: inline-block;
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top-color: #3B82F6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-icon {
  width: 64px;
  height: 64px;
  fill: #cbd5e1;
  margin-bottom: 16px;
}

.loading p,
.empty-state p {
  color: #94a3b8;
  font-size: 14px;
  margin-top: 12px;
}

/* 动画 */
@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
